// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__V19SM","title":"AfterBackImages_title__29rWF","images":"AfterBackImages_images__3XNVK"};